import { ORDER_ORGANIZATION_ROLE } from '@schuettflix/interfaces';

export const ORGANIZATION_ROLE_LABEL = {
    CUSTOMER: 'organization.roleName.customer',
    SUPPLIER: 'organization.roleName.supplier',
    CARRIER: 'organization.roleName.carrier',
    CUSTOM: 'organization.roleName.servicePartner',
} as const satisfies Record<ORDER_ORGANIZATION_ROLE, string>;
